import { z } from 'zod';
import { Temporal } from 'temporal-polyfill';

import { studentGroupSchema } from './student-group-shared.js';
import { userWithCoachProfileSchema } from './user.js';
import { studentGroupWithScheduleAndLevelSchema } from './student-group.js';
import { paginatedResponse } from './util-schema-types.js';

export const plainStudentGroupAuditSchema = z.object({
  id: z.string(),
  studentGroupId: z.string(),
  originalCoachId: z.string().nullable(),
  substituteCoachId: z.string().nullable(),
  coachAssignedAtPlainDate: z.instanceof(Temporal.PlainDate).nullable(),
  coachUnassignedAtPlainDate: z.instanceof(Temporal.PlainDate).nullable(),
  reassigned: z.boolean(),
});
export type PlainStudentGroupAudit = z.infer<typeof plainStudentGroupAuditSchema>;

export const studentGroupAuditSchema = plainStudentGroupAuditSchema.extend({
  studentGroup: studentGroupSchema,
  originalCoach: userWithCoachProfileSchema.nullable(),
  substituteCoach: userWithCoachProfileSchema.nullable(),
});
export type StudentGroupAudit = z.infer<typeof studentGroupAuditSchema>;

export const studentGroupAuditWithClassTimeLevelSchema = studentGroupAuditSchema.extend({
  studentGroup: studentGroupWithScheduleAndLevelSchema,
  droppedByTeacher: z.boolean(),
});
export type StudentGroupAuditWithClassTimeLevel = z.infer<typeof studentGroupAuditWithClassTimeLevelSchema>;

export const createStudentGroupAuditOptionsSchema = z.object({
  studentGroupId: z.string(),
  originalCoachId: z.string(),
  substituteCoachId: z.string().nullable().optional(),
  coachAssignedAt: z.string().nullable().optional(),
  coachUnassignedAt: z.string().nullable().optional(),
  reassigned: z.boolean().optional(),
});
export type CreateStudentGroupAuditOptions = z.infer<typeof createStudentGroupAuditOptionsSchema>;

export const updateStudentGroupAuditOptionsSchema = createStudentGroupAuditOptionsSchema.partial();
export type UpdateStudentGroupAuditOptions = z.infer<typeof updateStudentGroupAuditOptionsSchema>;

export const getCoachReassignedStudentGroupsResultsSchema = paginatedResponse.extend({
  reassignedStudentGroups: z.array(studentGroupAuditWithClassTimeLevelSchema),
});
export type GetCoachReassignedStudentGroupsResults = z.infer<typeof getCoachReassignedStudentGroupsResultsSchema>;
